import {ApolloClient, createHttpLink, from, InMemoryCache} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import { errorLink } from './errorLink';
import { getToken } from 'utils/auth';

// 创建HTTP链接
const httpLink = createHttpLink({
    uri: '/api/graphql',
});

// 认证链接
const authLink = setContext((_, {headers}) => {
    // 获取本地存储的token
    const token = getToken();

    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
        },
    };
});

// 创建Apollo Client实例
export const client = new ApolloClient({
    link: from([errorLink, authLink, httpLink]),
    cache: new InMemoryCache({
        typePolicies: {
            PickupTaskAppointmentWithAddressType: {
                keyFields: ['id', 'taskId'], // 使用id和taskId组合作为缓存键
            },
        },
    }),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
        },
    },
});
